import { format } from 'date-fns';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { getEmployeeById } from 'modules/beneficiaries/redux/employeeActions';
import EmployeeHistoric from 'modules/beneficiaries/components/EmployeeHistoric';
import EmployeePersonal from 'modules/beneficiaries/components/EmployeePersonal';
import EmployeeSociety from 'modules/beneficiaries/components/EmployeeSociety';

import cleanCIF from 'utils/cleanCIF';
import { getEmployeeCIF, getEmployeeFirstEffectiveDate } from 'utils/employees';

import { dateFormat } from 'constants/formats';

export const useEmployeeDetail = () => {
  const dispatch = useDispatch();
  const { employeeId } = useParams();

  const actualSociety = useSelector((state) => state.society?.actualSociety);

  const [actualEmployee, setActualEmployee] = useState();
  const [employeeIncentiveData, setEmployeeIncentiveData] = useState(null);
  const [incorporationDate, setIncorporationDate] = useState(null);
  const [pages, setPages] = useState([]);

  const getEmployeeIdData = async (id) => {
    try {
      const employeeData = await dispatch(getEmployeeById(id));
      setActualEmployee(employeeData);
    } catch (error) {
      console.error(error); // eslint-disable-line no-console
    }
  };

  useEffect(() => {
    if (employeeId) {
      getEmployeeIdData(employeeId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employeeId]);

  useEffect(() => {
    if (actualSociety && actualEmployee) {
      const firstEffectiveDate = getEmployeeFirstEffectiveDate(actualEmployee);
      const formattedDate = firstEffectiveDate
        ? format(new Date(firstEffectiveDate), dateFormat)
        : '-';

      setIncorporationDate(formattedDate);

      const employeeCIF = getEmployeeCIF(actualEmployee);
      const employeeBeneficiaries =
        actualSociety?.beneficiaries?.filter(
          (beneficiary) =>
            cleanCIF(beneficiary?.cif) === cleanCIF(employeeCIF)
        ) || null;

      if (employeeBeneficiaries?.length) {
        const societyIdValue = actualSociety?.['_id'];
        const planId = employeeBeneficiaries[0]?.plan;
        const beneficiaryId = employeeBeneficiaries[0]?.['_id'];

        const beneficiaryURL = `/detalle-beneficiario/${societyIdValue}/${planId}/${beneficiaryId}`;

        const incentiveData = {
          beneficiaryURL,
        };

        setEmployeeIncentiveData(incentiveData);
      }

      const currentPages = [
        <EmployeeSociety
          key="EmployeeSociety"
          society={actualSociety}
          employee={actualEmployee}
        />,
        <EmployeePersonal
          key="EmployeePersonal"
          society={actualSociety}
          employee={actualEmployee}
          incorporationDate={formattedDate}
        />,
        <EmployeeHistoric
          key="EmployeeHistoric"
          society={actualSociety}
          employee={actualEmployee}
        />,
      ];

      setPages(currentPages);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actualEmployee, actualSociety]);

  return {
    data: {
      pages,
      actualEmployee,
      actualSociety,
      incorporationDate,
      employeeIncentiveData,
    },
  };
};
